module.exports = __webpack_public_path__ + "img/checkbox_active_small.c5a63439.svg";